
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 15","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 13.575H1.2a.6.6 0 00-.6.6v.675c0 .082.067.15.15.15h14.7a.15.15 0 00.15-.15v-.675a.6.6 0 00-.6-.6zM3.33 12a.749.749 0 00.113-.01l3.154-.553a.184.184 0 00.1-.052l7.947-7.948a.186.186 0 000-.264L11.53.053A.186.186 0 0011.396 0a.186.186 0 00-.133.054L3.315 8.002a.19.19 0 00-.053.1l-.553 3.154a.628.628 0 00.176.558c.124.12.28.186.446.186z"}})])
          )
        }
      }
    